import React, { Component } from 'react';
import { defaultHeaders } from './util';
import * as util from "./util";
import {Header} from './header.js';
import {Footer} from './footer.js';
import {
  ProductRating, ProductDetailsButtons, ProductMediaMultiParent,
  ProductReviews, ProductPrice, CommUserInfo , ProductDescriptionOther, ProductTypeWithoutParantheses, ProductTypeWithLabel
} from './product-details';
import { CategoryPathWithLabel } from './show-categorypath.js';
import './product-details.css';

let faqProductDetails = [
  {
    content: "Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact-us/#contactform'>hier</a>.",
    title: "Nicht fündig geworden?",
    key: 0
  }
];

export class OtherDetails extends Component {
  constructor(props) {
    super(props);
    this.getOtherDetails = this.getOtherDetails.bind(this);

    this.state = {
      id: this.props.match.params['id'],
      name: '',
      board: '',
      uuid: '',
      type: 'Hardware und sonstige Angebote',
      categories: '',
      aim: '',
      desc: '',
      is_public: false,
      tags: [],
      price: 0,
      pdf_files: '',
      image_files: '',
      video_files: '',
    }

    if (!util.isCommercialUser() && !util.isNonCommercialUser() && this.id !== undefined) {
      util.loginGuest( () => this.getOtherDetails(this.props.match.params['id']) );
    } else {
      this.getOtherDetails(this.props.match.params['id']);
    }
  }

  componentWillReceiveProps(nextProps) {
    const newID = parseInt(nextProps.match.params['id'], 10);
    const oldID = parseInt(this.state.id, 10);
    if (oldID !== newID) {
      this.getOtherDetails(newID);
      this.setState({ id: newID });
    }
  }

  getOtherDetails(productID) {
    const self = this;
    const url = `/api/show-other-product?id=${productID}`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        alert('Productdetails konnten nicht geladen werden.');
        console.error('Could not fetch product details.', exception);
      });

    promise.then(function (json) {
      localStorage.setItem('product-name', json.name);
      self.setState({
        name: (json.name ? json.name : '(kein Name)'),
        board: json.board ? json.board : '',
        uuid: json.uuid ? json.uuid : '',
        aim: (json.aim ? json.aim : '(keine Beschreibung)'),
        categories: (json.categories ? json.categories : '(keine Beschreibung)'),
        is_public: (json.is_public ? json.is_public : '(keine Beschreibung)'),
        tags: (json.tags ? json.tags : '(keine Beschreibung)'),
        price: (json.price !== undefined ? json.price : '(keine Beschreibung)'),
        pdf_files: (json.pdf_files ? json.pdf_files : '(Nicht Vorhanden)'),
        image_files: (json.image_files ? json.image_files : '(Nicht Vorhanden)'),
        video_files: (json.video_files ? json.video_files : '(Nicht Vorhanden)'),
      });
      return;
    });
    return;
  }

  render() {
    return (
   <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className="productHeader1">
              {/* <ProductType name={this.state.name} productType={this.state.type} />*/}
              <ProductTypeWithoutParantheses name={this.state.name} />
            </div>
           
            <ProductDetailsButtons history={this.props.history} board={this.state.board} productID={this.state.id} productType={this.state.type} productName={this.state.name} price={this.state.price} onNewMessage={this.props.onNewMessage} />
       
          <div className="productInfoHeader">
        
        {util.isGuestUser() && <h3>Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur für eingeloggte Nutzer sichtbar.</h3>}
        <ProductTypeWithLabel  productType={this.state.type} />
        <CommUserInfo id={this.props.match.params['id']} table={"other"}/>
        <CategoryPathWithLabel ids={this.state.categories} startID={2} />
        <ProductRating uuid={this.state.uuid} />
        {!util.isGuestUser() && <ProductPrice price={this.state.price} />}
        </div>


        <ProductTabsOther
            onNewMessage={this.props.onNewMessage}
            uuid={this.state.uuid}
            productID={this.state.id}
            categories={this.state.categories}
            tags={this.state.tags}
            aim={this.state.aim}
            is_public={this.state.is_public}
            pdf_files={this.state.pdf_files}
            image_files={this.state.image_files}
            video_files={this.state.video_files} />
       
        <ProductDetailsButtons history={this.props.history} board={this.state.board} productID={this.state.id} productType={this.state.type} productName={this.state.name} price={this.state.price} onNewMessage={this.props.onNewMessage} />
       
      </div>
      </div> 
      <Footer faqs={faqProductDetails} />
      </div>
    )
  }
}

class ProductTabsOther extends Component {
  constructor(props) {
    super(props);
    this.makeActive = this.makeActive.bind(this);
    this.state = { activeTab: 0 };
  }

  makeActive(i) {
    this.setState({ activeTab: i });
  }

  render() {
    return (
      <div className="ProductTabs">
        <div className="ProductTabsButtons">
          <button className={this.state.activeTab === 0 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(0)} >Beschreibung</button>
          <button className={this.state.activeTab === 1 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(1)} >Reviews</button>
          <button className={this.state.activeTab === 2 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(2)} >Medien</button>
          <ProductDescriptionOther style={this.state.activeTab === 0 ? null : { display: 'none' }}
                                   desc={this.props.desc}
                                   tags={this.props.tags}
                                   aim={this.props.aim}/>
          <ProductReviews uuid={this.props.uuid} style={this.state.activeTab === 1 ? null : { display: 'none' }}
                          onNewMessage={this.props.onNewMessage} />
          <ProductMediaMultiParent style={this.state.activeTab === 2 ? null : { display: 'none' }}
                                   heading1={'Dokumentation'}
                                   uuids1={this.props.pdf_files}
                                   heading2={'Beschreibende Bilder oder Screenshots'}
                                   uuids2={this.props.image_files}
                                   heading3={'Video'}
                                   uuids3={this.props.video_files}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/other-show.js